import {
  LEADS_STEP_CONVERSATION_PANEL,
  LEADS_STEP_DETAILS_PANEL,
  LEADS_STEP_INBOX,
  LEADS_STEP_INBOX_TAB_CONVERSATIONS,
  LEADS_STEP_INBOX_TAB_INQUIRIES,
  LEADS_STEP_INBOX_TAB_INQUIRIES_PLANNERS,
  LEADS_STEP_INBOX_TAB_PROSPECTS,
  NAV_STEP_DASHBOARD,
  NAV_STEP_LEADS,
  NAV_STEP_RESOURCES,
  SPLIT_SCREEN_STEP_EDIT,
  SPLIT_SCREEN_STEP_PREVIEW,
  SPLIT_SCREEN_STEP_PUBLISH,
} from './StepContent';

export const SPLIT_SCREEN_STEPS = [
  SPLIT_SCREEN_STEP_EDIT,
  SPLIT_SCREEN_STEP_PREVIEW,
  SPLIT_SCREEN_STEP_PUBLISH,
];

export const NAV_STEPS = [NAV_STEP_DASHBOARD, NAV_STEP_LEADS, NAV_STEP_RESOURCES];

export const LEADS_STEPS = [
  LEADS_STEP_INBOX,
  LEADS_STEP_INBOX_TAB_PROSPECTS,
  LEADS_STEP_INBOX_TAB_INQUIRIES,
  LEADS_STEP_INBOX_TAB_CONVERSATIONS,
  LEADS_STEP_CONVERSATION_PANEL,
  LEADS_STEP_DETAILS_PANEL,
];

export const LEADS_STEPS_PLANNERS = [
  LEADS_STEP_INBOX,
  LEADS_STEP_INBOX_TAB_PROSPECTS,
  LEADS_STEP_INBOX_TAB_INQUIRIES_PLANNERS,
  LEADS_STEP_INBOX_TAB_CONVERSATIONS,
  LEADS_STEP_CONVERSATION_PANEL,
  LEADS_STEP_DETAILS_PANEL,
];
